import { useEffect } from 'react';
import { Severity, usePushNotifications } from 'services/NotificationService';
import {
  useGenerateFacebookAuthUrlQuery,
  useGenerateGoogleAuthUrlQuery
} from 'api/kms/ThirdPartyAuth/generateAuthUrl.query';
import { useThirdPartyAuthCallback } from './useThirdPartyAuthCallback';

export const useThirdPartyAuth = () => {
  const pushNotifications = usePushNotifications();

  const [generateFacebookAuthUrl, { data: facebookData }] = useGenerateFacebookAuthUrlQuery();
  const [generateGoogleAuthUrl, { data: googleData }] = useGenerateGoogleAuthUrlQuery();

  const callbackVm = useThirdPartyAuthCallback();

  const authenticateFacebook = async () => {
    try {
      await generateFacebookAuthUrl();
    } catch (error) {
      pushNotifications({
        title: 'Authenticate Facebook',
        severity: Severity.ERROR,
        message: 'Something went wrong'
      });
    }
  };

  const authenticateGoogle = async () => {
    try {
      await generateGoogleAuthUrl();
    } catch (error) {
      pushNotifications({
        title: 'Authenticate Google',
        severity: Severity.ERROR,
        message: 'Something went wrong'
      });
    }
  };

  useEffect(() => {
    if (!facebookData?.generateFacebookAuthUrl) return;

    window.location.href = facebookData?.generateFacebookAuthUrl;
  }, [facebookData]);

  useEffect(() => {
    if (!googleData?.generateGoogleAuthUrl) return;

    window.location.href = googleData?.generateGoogleAuthUrl;
  }, [googleData]);

  return { authenticateFacebook, authenticateGoogle, isCallback: callbackVm.isCallback };
};
